module.exports = __webpack_public_path__ + "img/security-audit-img-5.a581fcc3.png";